import React from 'react'
import styled from '@emotion/styled'
import Ajanlatkeres from '../containers/Ajanlatkeres'
import i00001 from '../images/szigeteles/00001.jpg'
import i00002 from '../images/szigeteles/00002.jpg'
import i00003 from '../images/szigeteles/00003.jpg'
import i00004 from '../images/szigeteles/00004.jpg'
import i00005 from '../images/szigeteles/00005.jpg'
import i00006 from '../images/szigeteles/00006.jpg'
import i00007 from '../images/szigeteles/00007.jpg'
import i00008 from '../images/szigeteles/00008.jpg'
import i00009 from '../images/szigeteles/00009.jpg'
import i00010 from '../images/szigeteles/00010.jpg'

const Main = styled.main`
  margin-top: 70px;
  line-height: 1.5rem;
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2.5rem;
  }
`

const SubTitle = styled.h3`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2rem;
  }
`

const Section = styled.section`
  position: relative;
  padding: 0 1rem;
  padding-bottom: 8px;
  margin: 2rem 0;

  a {
    text-decoration: none;
    color: initial;
  }

  ul {
    list-style: circle;

    li {
      margin: 0.5rem 0;

      a:after {
        content: ' ›';
      }
    }
  }

  &:first-of-type {
    margin-bottom: 4rem;
  }

  &:nth-of-type(2n) {
    background: linear-gradient(transparent 80px, rgba(39, 82, 54, 0.2) 80px, rgba(39, 82, 54, 0.2) 100%);

    ${SubTitle} {
      // color: #fff;
    }

    &:before {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      top: calc(80px - 2rem);
      width: 100%;
      height: 2rem;
      background: linear-gradient(to right top, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }

    &:after {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      bottom: -2rem;
      width: 100%;
      height: 2rem;
      background: linear-gradient(to left bottom, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }
  }

  @media (min-width: 64em) {
    p,
    ul,

    ${Title}, ${SubTitle} {
      margin: 2rem auto;
      max-width: 960px;
    }

    &:nth-of-type(2n) {
      &:before {
        top: calc(80px - 4rem);
        height: 4rem;
      }

      &:after {
        bottom: -4rem;
        height: 4rem;
      }
    }
  }
`

const Images = styled.section`
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  height: 320px;
  margin: 0 -1rem;
  width: calc(100% + 2rem);
  display: flex;
  flex-direction: row;

  img {
    flex: 1;
    display: block;
    height: 100%;
  }

  img + img {
    margin-left: 5px;
  }

  @media (min-width: 64em) {
    overflow-x: auto;
    margin: 0 auto;
    max-width: 1540px;
    height: auto;
    flex-wrap: wrap;

    img {
      flex: 1;
      display: block;
      width: 30%;
      // height: auto;
      margin: 5px;
    }
  }
`

const ScrollIndicator = styled.span`
  text-align: center;
  width: 100%;
  display: block;
  font-size: 0.8rem;
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  color: #fff;

  @media (min-width: 64em) {
    display: none;
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        {/* <Title>Tetőszigetelés</Title> */}
        {/* <p>Válasszon az alábbiak közül:</p>
        <ul>
          <li>
            <a href="#tetoszigeteles">Tetőszigetelés</a>
          </li>
        </ul>
      </Section>
      <Section> */}
        <SubTitle id="tetoszigeteles">Tetőszigetelés</SubTitle>
        <p>
          Az I. osztályú, kivitelezésének titka a jó minőségű alapanyagok használata és a szakmai hozzáértés. A
          kivitelezése során első feladatunknak, mihamarabb kizárni a csapadékvizet az épületből. A tetők, térelhatároló
          szerkezetek (lapos tetők, zöld tetők, teraszok, erkélyek stb.), melynek vízszigetelésére ajánljuk a modifikált
          bitumenes vízszigetelő lemezeket, EPDM gumiszegeteléseket és lágy PVC lemez szigeteléseket. Előnye, hogy
          széles körben alkalmazható a szigetelések terén, alacsony hajlásszögű, magastetős épületek esetében is. Széles
          típusválasztéka igazodik a szigetelés típusaihoz, gyártástechnológiája folyamatosan ellenőrzött, garantálva
          ezzel a biztonságos, modern vízszigetelő technológiát, és a hosszú élettartamot a szigetelt tetőkön. A tető
          elsődleges szerepe az esővíz távol tartása és mielőbbi elvezetése.
        </p>
        <p>Cégünk által alkalmazott technológiák:</p>
        <ul>
          <li>Modifikált nehéz lemezes szigetelés </li>
          <li>Resitrix SKW gumis szigetelés </li>
          <li>PVC szigetelés</li>
          <li>Kenhető Bitumenes szigetelés </li>
          <li>Kenhető vastag fóliázás </li>
        </ul>
      </Section>
      <Section>
        <SubTitle>Zsindely hatású vízszigetelés. Zsindelyezés.</SubTitle>
        <p>
          A technológia lényege az azbeszt pala a helyén marad és erre kerül rámelegítésre a vízszigetelés. A mások
          formája a szegezett zsindelyfedés, melynek OSB alapot kell biztosítani alátétlemezzel, itt a fedés bontásra
          kerül.
        </p>
        <p>Előnyök, amelyeket az általunk alkalmazott modern és szakszerű technológia biztosít:</p>
        <ul>
          <li>a bontás elkerülése gyorssá és gazdaságossá teszi az épület tetőfelújítását </li>
          <li>a meglévő tetőfedés nem kerül lebontásra, így biztosítjuk munka közben a beázás mentességét </li>
          <li>várható élettartama megnő</li>
          <li>megjelenése esztétikus, színes.</li>
          <li>a speciális kerámiaőrlemény biztosítja az anyag színtartósságát </li>
          <li>a szigetelőanyag felépítése miatt szükségtelenné válik a hófogók beépítése </li>
          <li>
            ÉMI által ellenőrzött termék és technológia, az EN ISO 9001 minőségtanúsítvány követelményeinek megfelel{' '}
          </li>
          <li>nem kerül azbeszt a levegőbe</li>
          <li>nincs veszélyes hulladék elszállítás, melynek költsége igen jelentős.</li>
        </ul>
      </Section>
      <Section>
        <SubTitle id="kepek">Képek</SubTitle>
        <Images>
          <img src={i00001} alt="" />
          <img src={i00002} alt="" />
          <img src={i00003} alt="" />
          <img src={i00004} alt="" />
          <img src={i00005} alt="" />
          <img src={i00006} alt="" />
          <img src={i00007} alt="" />
          <img src={i00008} alt="" />
          <img src={i00009} alt="" />
        </Images>
        <ScrollIndicator>◀ ● ▶</ScrollIndicator>
      </Section>
      <Ajanlatkeres />
    </Main>
  </div>
)
